import { render, staticRenderFns } from "./DpModal.vue?vue&type=template&id=140cde80&"
import script from "./DpModal.vue?vue&type=script&lang=js&"
export * from "./DpModal.vue?vue&type=script&lang=js&"
import style0 from "./DpModal.vue?vue&type=style&index=0&id=140cde80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports